// @flow
import React from "react";

function Dismiss(){
  return (
    <div className="Vlt-modal__dismiss" />
  )
}
export default Dismiss;